import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import FileUpload from "@/components/FileUpload";
import { ShieldCheck, FileText, IdCard, Trash2 } from "lucide-react";

function SectionCard({ icon: Icon, title, subtitle, testid, children }) {
  return (
    <div className="kpi-card" data-testid={testid}>
      <div className="flex items-center gap-2 mb-3">
        <Icon className="w-4 h-4 text-slate-500"/>
        <div>
          <div className="font-display font-semibold text-sm text-slate-900">{title}</div>
          {subtitle && <div className="text-[11px] text-slate-500 -mt-0.5">{subtitle}</div>}
        </div>
      </div>
      {children}
    </div>
  );
}

function Agreement({ label, accepted, testid }) {
  return (
    <div className="flex items-center justify-between border border-slate-200 rounded-md p-3" data-testid={testid}>
      <div className="flex items-center gap-2 text-sm">
        <Checkbox checked={accepted} disabled/>
        <span className="font-medium text-slate-900">{label}</span>
      </div>
      <span className={`pill ${accepted ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-700 border-amber-200"}`}>{accepted ? "Accepted" : "Pending"}</span>
    </div>
  );
}

function DocRow({ icon: Icon, label, file_id, accept, testid, onUpload, onDelete, onPreview }) {
  return (
    <div className="flex items-center justify-between border border-slate-200 rounded-md p-3 gap-3" data-testid={testid}>
      <div className="flex items-center gap-2 text-sm flex-1 min-w-0">
        <Icon className={`w-4 h-4 ${file_id ? "text-cyan-700" : "text-slate-400"}`}/>
        <span className="font-medium text-slate-900">{label}</span>
        {file_id ? (
          <button onClick={onPreview} className="text-xs text-cyan-700 hover:underline ml-2" data-testid={`${testid}-view`}>Preview</button>
        ) : (
          <span className="text-xs text-slate-400 ml-2">Not uploaded</span>
        )}
      </div>
      <div className="flex items-center gap-2">
        <div className="w-32"><FileUpload accept={accept} testid={`${testid}-upload`} label={file_id ? "Replace" : "Upload"} onUploaded={onUpload}/></div>
        {file_id && <Button size="sm" variant="outline" onClick={onDelete} className="text-red-600 border-red-200 hover:bg-red-50" data-testid={`${testid}-delete`}><Trash2 className="w-3.5 h-3.5"/></Button>}
      </div>
    </div>
  );
}

export function AgreementsCard({ u, onUpload, onDelete, onPreview }) {
  return (
    <SectionCard icon={ShieldCheck} title="Agreements & Documents" subtitle="Section 8" testid="section-agreements">
      <div className="space-y-3">
        <Agreement label="NDA" accepted={u.nda_accepted} testid="agree-nda"/>
        <Agreement label="Code of Conduct" accepted={u.code_of_conduct_accepted} testid="agree-coc"/>
        <Agreement label="Data Privacy" accepted={u.privacy_accepted} testid="agree-privacy"/>
        <DocRow icon={FileText} label="Resume / CV" file_id={u.resume_file_id} accept=".pdf,application/pdf" testid="doc-resume" onUpload={(f)=>onUpload("resume_file_id", f)} onDelete={()=>onDelete("resume")} onPreview={()=>onPreview(u.resume_file_id, "Resume / CV")}/>
        <DocRow icon={IdCard} label="National ID" file_id={u.national_id_file_id} accept="image/*,.pdf" testid="doc-national-id" onUpload={(f)=>onUpload("national_id_file_id", f)} onDelete={()=>onDelete("national_id")} onPreview={()=>onPreview(u.national_id_file_id, "National ID")}/>
      </div>
    </SectionCard>
  );
}
